export const HTTP_CODE_200 = '200';

export const VIRTUAL_PAGEVIEW = 'virtual_pageview';
